module.exports = __webpack_public_path__ + "image/investor-banner.jpg";